import { WorkspaceType } from '@flowx/designer/modules/workspaces/shared/commons.types'

import type { AnalyticsArea } from './analytics-area.entity'

export enum WorkspaceObject {
  WORKSPACE = 'workspace',
}

export enum WorkspaceAction {
  SELECTED = 'selected',
  MEMBER_ADDED = 'member_added',
  MEMBER_REMOVED = 'member_removed',
}

export type WorkspaceSelectedSource = 'switcher' | 'admin_list'

type WorkspaceSelectedProperties = {
  envType: WorkspaceType
  source: WorkspaceSelectedSource
  area: AnalyticsArea
}

export type WorkspaceSelectedEvent = {
  object: WorkspaceObject.WORKSPACE
  action: WorkspaceAction.SELECTED
}

export type WorkspaceAnalyticsObject = {
  event: WorkspaceSelectedEvent
  properties: WorkspaceSelectedProperties
}
